"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      margin: 0,
      paddingLeft: 0,
      listStyleType: 'none'
    }
  };
});
/**
 * @function
 *
 * @param {object} props
 * @param {Array<React.ReactNode>} props.messages
 *
 * @returns {React.ReactNode}
 *
 * @example
 * // TODO: Write example.
 */

var HelperMessages = function HelperMessages(_ref) {
  var messages = _ref.messages;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: classes.root
  }, messages.map(function (message) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: message
    }, message);
  }));
};

HelperMessages.propTypes = {
  messages: _propTypes["default"].arrayOf(_propTypes["default"].node).isRequired
};
var _default = HelperMessages;
exports["default"] = _default;